import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc CagFilterOverlay defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CagFilterOverlayService } from 'services/cagFilterOverlay';
 *
 * // create service instance and send/cancel request
 * const cagFilterOverlayService = new CagFilterOverlayService();
 * const result = await cagFilterOverlayService.fetchData( '<user-id>' ); // fetch data
 * cagFilterOverlayService.cancel(); // cancel an active request
 */
export class CagFilterOverlayService extends HttpService {

    // make request and fetch data
    async fetchAccountsList( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    ...get( response, 'body.component.data', [] ),
                },
            };
        } catch( errResponse ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // make request and fetch data
    async fetchGroupOptions( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    ...get( response, 'body.component.data', [] ),
                },
            };
        } catch( errResponse ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
